// QUICK ADD CUSTOM

const quickAddInputs = document.querySelectorAll('[id^="quick-add-variant-input-"]');
const quickAddSelectors = document.querySelectorAll('[id^="quick-add-variant-selector-"]');

quickAddSelectors.forEach((selector) => {
    selector.addEventListener('click' , (e) => {
        let button = e.currentTarget;
        quickAddInputs.forEach((input) => {
            input.checked = false;
        })
        document.querySelector(`#${button.dataset.value}`).checked = true;
    })
})


if (sessionStorage.getItem('la-dn-stickybar-hidden-insession') !== 'true') {
    const elemento = document.querySelector('.mm-fixed-top');
    const element2 = document.querySelector('.default-header.mm-fixed-top');

    if (elemento) {
        elemento.style.marginTop = '27px';
        element2.style.marginTop = '27px';
    }
}

// END QUICK ADD CUSTOM